import Actions from '../../odata/actions';

const actions = new Actions('integrationSetting', 'integrationSettings');

export default actions;
